export const getFiscalDetails = async () => {
    const response = await fetch(`/financial/fiscal/service_configs.json`);

    const contentType = response.headers.get('content-type');
    if (!contentType || !contentType.includes('application/json')) {
        throw new TypeError("Oops, não recebemos JSON!");
    }

    const data = await response.json();

    if (!response.ok) {
        throw new Error(`Erro ${response.status}: ${data.error}`);
    }

    return data;
};

export const createOrUpdateFiscalDetails = async ({ body }) => {
  const response = await fetch(`/financial/fiscal/service_configs`, {
    method: 'PUT',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(body)
  });

  const responseJson = await response.json();

  if (!response.ok) {
    throw new Error(`Error ${response.status}: ${responseJson.error}`);
  }

  return responseJson;
}

export const getFiscalServiceXML = async (id) => {
    const response = await fetch(`/financial/fiscal/service_invoices/${id}/xml`);

    if (!response.ok) {
        throw new Error(`Erro ${response.status}`);
    }

    const blob = await response.blob();
    return blob;
};

export const getFiscalServicePDF = async (id) => {
    const response = await fetch(`/financial/fiscal/service_invoices/${id}/pdf`);

    if (!response.ok) {
        throw new Error(`Erro ${response.status}`);
    }

    const blob = await response.blob();
    return blob;
};

